import React from 'react';
import { ModalKey } from './modal_key_context';
import { RequiredKeys } from 'types/utility_types';
import { MODAL_REGISTRY } from './registry';

type HasRequiredProps<T> = RequiredKeys<T> extends never ? false : true;

export type OpenFunction = <K extends ModalKey>(
  key: K,
  ...props: HasRequiredProps<
    React.ComponentProps<(typeof MODAL_REGISTRY)[K]>
  > extends true
    ? [props: React.ComponentProps<(typeof MODAL_REGISTRY)[K]>]
    : [props?: React.ComponentProps<(typeof MODAL_REGISTRY)[K]>]
) => void;

export type CloseFunction = <K extends ModalKey>(key?: K) => void;

export type ModalContextType = {
  open: OpenFunction;
  close: CloseFunction;
};

export const ModalContext = React.createContext<ModalContextType | undefined>(
  undefined
);
